import { resolveInstalledNodeScriptLaunchCandidates, resolveInstalledNodeScriptLaunchContract, verifyCliLaunchContract, } from "@wakeloop/adapter-core";
const DEFAULT_CLAUDE_CODE_COMMAND = "claude";
export async function resolveInstalledClaudeCodeLaunchCandidates(input) {
    const installedCandidates = await resolveInstalledNodeScriptLaunchCandidates({
        commandName: DEFAULT_CLAUDE_CODE_COMMAND,
        configuredCommand: normalizeOptionalText(process.env.WAKELOOP_DAEMON_RUNTIME_CLAUDE_CODE_BIN),
        displayName: "Claude Code",
    });
    if (!installedCandidates.ok) {
        return installedCandidates;
    }
    const candidates = (await Promise.all(installedCandidates.candidates.map(async (candidate) => {
        const verification = await verifyClaudeCodeLaunchContract({
            launchContract: candidate.launchContract,
            timeoutMs: input?.timeoutMs,
        });
        return verification.ok ? candidate : null;
    }))).filter((candidate) => {
        return candidate !== null;
    });
    if (candidates.length === 0) {
        return {
            errorMessage: "Claude Code is installed, but WakeLoop can't start it on this device.",
            ok: false,
        };
    }
    return {
        candidates,
        ok: true,
    };
}
export async function resolveInstalledClaudeCodeLaunchContract() {
    return await resolveInstalledNodeScriptLaunchContract({
        commandName: DEFAULT_CLAUDE_CODE_COMMAND,
        configuredCommand: normalizeOptionalText(process.env.WAKELOOP_DAEMON_RUNTIME_CLAUDE_CODE_BIN),
        displayName: "Claude Code",
    });
}
export async function verifyClaudeCodeLaunchContract(input) {
    return await verifyCliLaunchContract({
        cwd: input.cwd ?? process.cwd(),
        displayName: "Claude Code",
        launchContract: input.launchContract,
        probeArgs: ["--version"],
        timeoutMs: input.timeoutMs ?? resolveClaudeCodeTimeoutMs(),
    });
}
export function resolveClaudeCodeTimeoutMs() {
    // Explicit watchdog override only. Normal WakeLoop Wake execution has no fixed
    // Claude Code process timeout.
    const raw = normalizeOptionalText(process.env.WAKELOOP_DAEMON_RUNTIME_REQUEST_TIMEOUT_MS);
    if (!raw) {
        return null;
    }
    const parsed = Number.parseInt(raw, 10);
    if (!Number.isFinite(parsed) || parsed <= 0) {
        return null;
    }
    return parsed;
}
function normalizeOptionalText(value) {
    const normalized = String(value ?? "").trim();
    return normalized.length > 0 ? normalized : null;
}
